import { NamedResource } from "./namedResource";
import { ProjectConnectivityPolicy, GuidedFailureMode } from "./projectResource";
import { TenantedDeploymentMode } from "./tenantedDeploymentMode";
import { RunbookRetentionPeriod } from "./retentionPeriod";

interface RunbookResourceLinks {
    Self: string;
    Template: string;
    Project: string;
    RunbookSnapshotTemplate: string;
    RunbookRunTemplate: string;
    RunbookRunPreview: string;
    RunbookRunTenantPreview: string;
    RunbookSnapshots: string;
    CreateRunbookRun: string;
    RunbookProcesses: string;
    Progression: string;
    TaskRunDashboardItemsTemplate: string;
}

export interface RunbookResource extends NamedResource<RunbookResourceLinks> {
    Description: string;
    RunbookProcessId: string;
    PublishedRunbookSnapshotId?: string;
    ProjectId: string;
    SpaceId: string;
    ConnectivityPolicy: ProjectConnectivityPolicy;
    MultiTenancyMode: TenantedDeploymentMode;
    EnvironmentScope: RunbookEnvironmentScope;
    Environments: string[];
    DefaultGuidedFailureMode: GuidedFailureMode;
    RunRetentionPolicy: RunbookRetentionPeriod;
}

export type NewRunbookResource = Omit<RunbookResource, "Id" | "Links" | "SpaceId" | "RunbookProcessId" | "PublishedRunbookSnapshotId" | "ConnectivityPolicy" | "Environments">;

export enum RunbookEnvironmentScope {
    All = "All",
    Specified = "Specified",
    FromProjectLifecycles = "FromProjectLifecycles",
}

export default RunbookResource;
